import { useContext, useEffect, useRef } from "react";
import { WorkspaceContext } from "src/context/workspace";
import { useSiteSettings } from "src/context/SiteSettingsContext";
import useDevice from "src/hooks/useDevice";
import useIframeResize from "src/hooks/useIframeResize";

export default function DatagolEmbed({ content }) {
  const { details: workspaceDetails } = useContext(WorkspaceContext);
  const { site } = useSiteSettings();
  const { maxWidth } = useIframeResize({ workspaceDetails, site });
  const device = useDevice();
  const iframeWrapperRef = useRef(null);

  useEffect(() => {
    const iframe = iframeWrapperRef.current?.querySelector("iframe");
    if (!iframe) return;

    const handleLoad = () => {
      window.dispatchEvent(new CustomEvent("domo:iframe-loaded", {}));
    };

    iframe.addEventListener("load", handleLoad);
    return () => iframe.removeEventListener("load", handleLoad);
  }, [content?.embedUrl]);


  return (
    <div className="relative flex h-full w-full items-center justify-center">
      {content?.embedUrl && (
        <div
          ref={iframeWrapperRef}
          className="mx-auto h-full w-full overflow-auto"
          style={{ maxWidth: device === "desktop" ? maxWidth || "100%" : "100%" }}>
          <iframe
            id="iframe"
            title="DataGOL Embed"
            src={content.embedUrl}
            width="100%"
            height="100%"
            style={{ border: 0, margin: 0 }}
            allowFullScreen
            allow="fullscreen; clipboard-write"
          />
        </div>
      )}
    </div>
  );
}
